import {useQuery, UseQueryOptions, UseQueryResult} from '@tanstack/react-query';
import {fetchAgencyBidders} from '~/modules/Clients/api';
import {IBidder} from '~/modules/Bidders/models/Bidder';
import {ID} from '~/lib/model';

export const AGENCY_BIDDERS_QUERY_KEY = (agencyId: ID) =>
    ['agency-bidders', agencyId] as const;

export const useAgencyBiddersQuery = (
    agencyId: ID,
    options?: Omit<UseQueryOptions<IBidder[]>, 'queryKey' | 'queryFn'>
): UseQueryResult<IBidder[]> =>
    useQuery<IBidder[]>({
        queryKey: AGENCY_BIDDERS_QUERY_KEY(agencyId),
        queryFn: () => fetchAgencyBidders({agencyId}),
        ...options,
    });
